export const StateMixin = {
  data: () => ({
    states: {
      init: 'init',
      started_timer: 'started_timer',
      stopped_timer: 'stopped_timer',
      validation_phone: 'validation_phone',
      validated_phone: 'validated_phone'
    },
    state: 'init'
  }),
  computed: {
    is_init() {
      return this.state === this.states.init;
    },
    is_validated_phone() {
      return this.state === this.states.validated_phone;
    },
    is_validation_phone() {
      return this.state === this.states.validation_phone;
    },
    is_started_timer() {
      return this.state === this.states.started_timer;
    }
  }
};
